<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Lesson</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Lesson</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Lesson">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'LessonList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Course</label>
                    <multiselect
                      id="course_id"
                      name="course_id"
                      :options="Object.keys(pre.course_id)"
                      :custom-label="(opt) => pre.course_id[opt]"
                      v-bind:class="{ 'has-error': errors.has('course_id') }"
                      v-validate="'required'"
                      v-model="value.course_id"
                      class="course_id"
                      placeholder="Select Course"
                      @select="loadSection($event)"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                    ></multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('course_id')"
                    >
                      {{ errors.first("course_id") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Section</label>
                    <multiselect
                      name="section_id"
                      :options="Object.keys(pre.sections)"
                      :custom-label="(opt) => pre.sections[opt]"
                      v-bind:class="{ 'has-error': errors.has('sections') }"
                      v-validate="'required'"
                      v-model="value.section_id"
                      placeholder="Select section"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                    ></multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('section_id')"
                    >
                      {{ errors.first("section_id") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Lesson Title (English)</label>
                    <input
                      type="text"
                      id="lesson_title"
                      name="lesson_title"
                      v-bind:class="{ 'has-error': errors.has('lesson_title') }"
                      v-validate="'required'"
                      v-model="value.lesson_title"
                      class="form-control lesson_title"
                      placeholder="Lesson Title (English)"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('lesson_title')"
                    >
                      {{ errors.first("lesson_title") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Lesson Title (Bangla)</label>
                    <input
                      type="text"
                      id="lesson_title_bn"
                      name="lesson_title_bn"
                      v-bind:class="{
                        'has-error': errors.has('lesson_title_bn'),
                      }"
                      v-model="value.lesson_title_bn"
                      class="form-control lesson_title_bn"
                      placeholder="Lesson Title (Bangla)"
                    />
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Lesson Type</label>
                    <multiselect
                      name="lesson_type"
                      :options="lesson_types"
                      placeholder="Pick Lesson Type"
                      :searchable="true"
                      :multiple="false"
                      v-model="value.lesson_type"
                      v-validate="'required'"
                      v-bind:class="{ 'has-error': errors.has('lesson_type') }"
                      class="lesson_type"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('lesson_type')"
                    >
                      {{ errors.first("lesson_type") }}
                    </div>
                  </div>

                  <!-- <quiz
                    v-if="value.lesson_type == 'Quiz'"
                    :quiz="value.quiz"
                    @updateQuiz="updateQuiz"
                  ></quiz> -->
                  <add-quiz
                    v-if="value.lesson_type == 'Quiz'"
                    :quizzes="value.quizzes"
                    @updateQuiz="updateQuiz"
                  ></add-quiz>
                  <br />
                  <div v-if="value.lesson_type == 'Video'">
                    <div class="form-group">
                      <label class="control-label">Description (English)</label>
                      <ckeditor
                        id="description"
                        name="description"
                        v-model="value.description"
                        placeholder="Description"
                      ></ckeditor>
                    </div>
                    <div class="form-group">
                      <label class="control-label">Description (Bangla)</label>
                      <ckeditor
                        id="description_bn"
                        name="description_bn"
                        v-model="value.description_bn"
                        placeholder="Description (Bangla)"
                      ></ckeditor>
                    </div>
                    <div class="form-group">
                      <label class="control-label">Youtube Url</label>
                      <input
                        type="text"
                        id="youtube_url"
                        name="youtube_url"
                        v-bind:class="{
                          'has-error': errors.has('youtube_url'),
                        }"
                        v-model="value.youtube_url"
                        class="form-control youtube_url"
                        placeholder="Youtube Url"
                      />
                    </div>
                    <div class="form-group">
                      <label class="control-label">Youtube Video Id</label>
                      <input
                        type="text"
                        id="youtube_video_id"
                        name="youtube_video_id"
                        v-bind:class="{
                          'has-error': errors.has('youtube_video_id'),
                        }"
                        v-model="value.youtube_video_id"
                        class="form-control youtube_video_id"
                        placeholder="Youtube Video Id"
                      />
                    </div>
                    <div class="col-md-12">
                      <h4 class="site-heading my-3"><span>File</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="file_path"></label>
                      <div class="row align-items-center">
                        <div class="col-4">
                          <div class="input-group">
                            <div class="custom-file">
                              <input
                                type="file"
                                name="file_path"
                                class="custom-file-input"
                                id="file_path"
                                accept="video/mp4"
                                @change="uploadFile($event)"
                              />
                              <label class="custom-file-label" for="file_path"
                                >Choose file</label
                              >
                            </div>
                          </div>
                        </div>

                        <div class="form-group" v-if="value.file_path_name">
                          {{ value.file_path_name }}
                          &nbsp;
                          <i
                            class="fas fa-window-close"
                            @click="removeFile('file_path')"
                          ></i>
                        </div>
                      </div>
                      <span class="help text-info xs-text"
                        >Supported mimes: mp4</span
                      >
                      <br />
                      <div
                        class="help text-danger"
                        v-show="errors.has('file_path')"
                      >
                        {{ errors.first("file_path") }}
                      </div>
                    </div>

                    <div class="col-md-12">
                      <h4 class="site-heading my-3"><span>Other File</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="other_file"></label>
                      <div class="row align-items-center">
                        <div class="col-4">
                          <div class="input-group">
                            <div class="custom-file">
                              <input
                                type="file"
                                name="other_file"
                                class="custom-file-input"
                                id="other_file"
                                accept=".zip, .docx,.doc,.pdf"
                                @change="selectFile($event, 'other_file')"
                              />
                              <label class="custom-file-label" for="other_file"
                                >Choose file</label
                              >
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="value.other_file_name">
                          {{ value.other_file_name }}
                          &nbsp;
                          <i
                            class="fas fa-window-close"
                            @click="removeFile('other_file')"
                          ></i>
                        </div>
                      </div>
                      <span class="help text-info xs-text"
                        >Supported mimes: zip, docx, doc, pdf</span
                      >
                      <br />
                      <div
                        class="help text-danger"
                        v-show="errors.has('other_file')"
                      >
                        {{ errors.first("other_file") }}
                      </div>
                    </div>
                    <div class="col-md-12">
                      <h4 class="site-heading my-3">
                        <span>Featured Image</span>
                      </h4>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="featured_image"></label>
                      <div class="row align-items-center">
                        <div class="col-4">
                          <div class="input-group">
                            <div class="custom-file">
                              <input
                                type="file"
                                name="featured_image"
                                class="custom-file-input"
                                id="featured_image"
                                accept="image/png, image/jpeg, image/jpg"
                                @change="selectFile($event, 'featured_image')"
                              />
                              <label
                                class="custom-file-label"
                                for="featured_image"
                                >Choose file</label
                              >
                            </div>
                          </div>
                        </div>
                        <div
                          class="form-group"
                          v-if="value.featured_image_name"
                        >
                          <img
                            alt="preview image"
                            v-if="value.featured_image"
                            v-bind:src="value.featured_image"
                            width="100"
                            height="100"
                            class="img-circle"
                          />
                          {{ value.featured_image_name }}
                          &nbsp;
                          <i
                            class="fas fa-window-close"
                            @click="removeFile('featured_image')"
                          ></i>
                        </div>
                      </div>
                      <span class="help text-info xs-text"
                        >Supported mimes: jpeg, jpg, png</span
                      >
                      <br />
                      <div
                        class="help text-danger"
                        v-show="errors.has('featured_image')"
                      >
                        {{ errors.first("featured_image") }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Conversion Status</label>
                    <select
                      class="form-control"
                      style="width: 100%"
                      v-bind:class="{
                        'has-error': errors.has('conversion_status'),
                      }"
                      v-validate="'required'"
                      name="conversion_status"
                      v-model="value.conversion_status"
                      id="conversion_status"
                    >
                      <option value="not_started">Not Started</option>
                      <option value="completed">Completed</option>
                    </select>
                    <div
                      class="help text-danger"
                      v-show="errors.has('conversion_status')"
                    >
                      {{ errors.first("conversion_status") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Duration (In Minutes)</label>
                    <input
                      type="number"
                      min="0"
                      id="duration"
                      name="duration"
                      v-model="value.duration"
                      class="form-control duration"
                      placeholder="Duration"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Display Order</label>
                    <input
                      type="number"
                      min="0"
                      id="display_order"
                      name="display_order"
                      v-bind:class="{
                        'has-error': errors.has('display_order'),
                      }"
                      v-model="value.display_order"
                      class="form-control display_order"
                      placeholder="Display Order"
                    />
                  </div>
                  <add-vocabulary
                    :vocabularies="value.vocabularies"
                    @updateVocabularies="updateVocabularies"
                  />
                  <add-faq :faqs="value.faqs" @updateFaqs="updateFaqs" />
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import CkEditorComponent from "../../../components/utils/CKEditorComponent.vue";
import AddVocabulary from "./components/AddVocabulary.vue";
import AddFaq from "./components/AddFaq.vue";
import { LearningApi } from "@/services/api";
// import Quiz from "./components/Quiz.vue";
import AddQuiz from "./components/AddQuiz.vue";

export default {
  name: "LessonForm",
  metaInfo: {
    title: "Lesson | Dotlines",
  },
  components: {
    DatePicker,
    CkEditorComponent,
    AddVocabulary,
    AddFaq,
    AddQuiz,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    lesson_types: ["Video", "Quiz"],
    value: {
      lesson_type: "Video",
      file_path: "",
      file_path_name: "",
      other_file: "",
      other_file_name: "",
      featured_image: "",
      featured_image_name: "",
      display_order: 999,
      duration: 0,
      vocabularies: [],
      faqs: [],
      quizzes: {},
    },
    pre: {
      course_id: {},
      sections: {},
    },
  }),
  methods: {
    uploadFile: function (event) {
      let _this = this;
      _this.is_loading = true;
      let formData = new FormData();
      formData.append("video_file", event.target.files[0]);
      axios({
        method: "POST",
        url: "/file-upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          _this.value["file_path"] = response.data.file_name;
          var filename = response.data.file_name
            ? response.data.file_name.split("videos/")
            : [];

          _this.value["file_path_name"] =
            filename.length > 0 ? filename[1] : "";
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
    selectFile: function (event, filename = "file_path") {
      try {
        let _this = this;
        _this.is_loading = true;
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          let index = filename + "_name";
          _this.value[filename] = reader.result;
          _this.value[index] = event.target.files[0].name;
          _this.is_loading = false;
        };
      } catch (e) {
        console.log(e);
      }
    },
    removeFile: function (filename = "file_path") {
      let name = filename + "_name";
      this.value[filename] = "";
      this.value[name] = "";
    },
    courseIdOptions: function () {
      return new Promise((resolve, reject) => {
        LearningApi.getCourseOptions()
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    loadSection: function (course_id) {
      return new Promise((resolve, reject) => {
        LearningApi.getSectionOptions(course_id)
          .then((response) => {
            this.pre.sections = response.data;
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/lessons";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/lessons/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "LessonList" });
            })
            .catch((errors) => {
              _this.$toaster.error(errors.response.data.message);
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/lessons/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.courseIdOptions().then((course_id) => {
        this.pre.course_id = course_id;
      });
      /* await this.loadSection().then((section_id) => {
        this.pre.section_id = section_id;
      });
 */
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.loadSection(this.value.course_id);
            this.value.file_path = this.value.file_path;
            var filename = this.value.file_path
              ? this.value.file_path.split("videos/")
              : [];
            this.value.file_path_name = filename.length > 0 ? filename[1] : "";

            this.value.other_file = this.value.other_file;
            var filename = this.value.other_file
              ? this.value.other_file.split("files/")
              : [];
            this.value.other_file_name = filename.length > 0 ? filename[1] : "";

            this.value.featured_image =
              this.API_ASSET_UPLOAD_URL +
              "learning/" +
              this.value.featured_image;
            var filename = this.value.featured_image
              ? this.value.featured_image.split("images/")
              : [];

            this.value.featured_image_name =
              filename.length > 0 ? filename[1] : "";
          })
          .catch((error) => {
            console.log(error.response);
          });
      }

      this.is_loading = false;
    },
    updateVocabularies: function (value) {
      this.value.vocabularies = value;
    },
    updateFaqs: function (value) {
      this.value.faqs = value;
    },
    updateVideo: function (value) {
      this.value.description = value.description;
    },
    updateQuiz: function (val) {
      this.value.quizzes = val;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
